import { render, staticRenderFns } from "./defaultAss.vue?vue&type=template&id=b9356f5c&"
import script from "./defaultAss.vue?vue&type=script&lang=js&"
export * from "./defaultAss.vue?vue&type=script&lang=js&"
import style0 from "./defaultAss.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports